<template>
    <b-container>
      <b-row>
        <b-col>
          <div class="text-grey1 ml-0">Book a Test > Diagnostic Centres</div>
          <b-card class="text-grey mt-4">
            <b-row>
              <b-col md="3">
                <p class="ml-3 mt-2 distance-filter">Filter By Distance</p>
              </b-col>
              <b-col md="2">
                <b-form-input
                  id="range-1"
                  v-model="value"
                  type="range"
                  min="0"
                  max="10"
                  class="mt-2"
                >
                </b-form-input>
              </b-col>
              <b-col md="4">
                <div class="mt-2">Distance: {{ value }}km to {{ max }}km</div>
              </b-col>
              <b-col md="3">
                <b-row>
                  <b-form-input
                    class="mt-2 col-10 border-radius-left-40"
                    placeholder="Search Store..."
                    v-model="storeName"
                  ></b-form-input>
                  <button
                    class="col search-button mt-2 ml-n1 border-radius-r-40"
                    @click="storeResult"
                  >
                    <b-icon icon="search" class="margin-top-4"></b-icon>
                  </button>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
          <div>
            <sections-slider
              :list="pharmacyStore"
              :hasBackground="false"
              :withoutSlider="true"
              class="pharmacyshop-sec"
            >
              <template slot="default" slot-scope="{ listItem }">
                <div class="item-box">
                  <items-item
                    :itemWhite="true"
                    :product="listItem"
                    :rating="
                      getProductFeedbackData(listItem._id).ratingAverage || 2.5
                    "
                    :marketRoute="{
                      name: 'diagnostic-center-detail',
                      params: {
                        id: listItem._id,
                        items: listItem.office.officeName,
                      },
                    }"
                  >
                  </items-item>
                </div>
              </template>
            </sections-slider>
          </div>
        </b-col>
      </b-row>
      <b-row>
      <b-col>
        <div class="main-banner">
          <img
            :src="
              (diagnosticBanner.icon && diagnosticBanner.icon.fileUrl) || ''
            "
            alt="Diagnostic Centers Bottom Banner"
          />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <sections-slider
          :list="itemSuggestions"
          subTitle="Recently Searched"
          :showTitle="true"
          :hasBackground="false"
          :hasButton="true"
          class="suggested-slider"
          :withSlider="true"
          :viewMorePage="{
            name: `health-care-listing`,
            params: {
              items: `Most Popular`,
            },
          }"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box ml-2 mr- 2">
              <items-item
                :itemNoBg="true"
                :product="listItem"
                :incrementDecrementKey="true"
                class="suggester-div"
              ></items-item>
            </div>
          </template>
        </sections-slider>
      </b-col>
    </b-row>
    </b-container>
  </template>
  
  <script>
  import { mapActions, mapGetters, mapState } from "vuex";
  export default {
    name: "pharmacyStore",
    components: {},
    data() {
      return { value: "0", max: "10", storeName: "" };
    },
    computed: {
      ...mapState({
      diagnosticBanner: (state) => state.healthCare.marketBanner,
        pharmacyStore: (state) => state["healthCare"].pharmacyStore,
        currentPosition: (state) => state.location.currentPosition,
        marketList: (state) => state["home"].marketList,
      }),
      ...mapGetters({
        getProductFeedbackData: "healthCare/getProductFeedbackData",
      }),
    },
    methods: {
      ...mapActions({
        fetchPharmacyStore: "healthCare/fetchPharmacyStore",
        fetchFeedbackData: "healthCare/fetchProductFeedback",
      }),
  
      async getPharmacyData() {
        const payload = {
          // name: "",
          // state: "",
          // city: "",
          // zip: "",
          // street: "",
          // market: this.$route.params.id,
          lat: this.currentPosition.Lat || 0,
          lng: this.currentPosition.Lng || 0,
          category: "SELLER",
          market: this.$route.params.marketid,
          // lat: 22.6636967,
          // lng: 87.74680710000001,
          radius: "10",
        };
        if (this.storeName) {
          payload.name = this.storeName;
        }
        await this.fetchPharmacyStore(payload);
      },
  
      async storeResult() {
        await this.getPharmacyData();
      },
  
      async getProductFeedback() {
        const payload = this.pharmacyStore.map((x) => {
          const catalogId = x.agreement.marketSegment[0].catalogId;
          return this.fetchFeedbackData({ _id: x._id, catalogId });
        });
        await Promise.all(payload);
      },
    },
    async mounted() {
      await this.getPharmacyData();
      await this.getProductFeedback();
      let payload = {
      city: "GHATAL",
      placement: "SHOP_TOP",
      provider: "62288a7d9e0dd452af89f0d1",
    };
    await this.$store.dispatch("healthCare/fetchMarketBanner", payload);
    },
  };
  </script>
  
  <style scoped>
  .distance-filter {
    font-size: 26 !important;
    font-weight: 600;
  }
  .text-grey1 {
    color: #aaa;
    background-color: transparent;
  }
  
  .text-grey {
    background-color: #f9f9f9;
  }
  
  .search-button {
    position: absolute;
    top: 0px;
    font-size: large;
    z-index: 1;
    right: 0;
    width: 46px;
    height: 37px;
    padding: 0px;
    background-color: black !important;
    color: #fff;
  }
  </style>
  